export default {
  reset_password_title: "重置密码",
  invalid_reset_token: "密码重置链接无效或已过期",
  invalid_reset_token_desc: "您提供的密码重置链接无效或已过期。请申请新的密码重置链接。",
  password_reset_success: "您的密码已成功重置",
  password_reset_success_desc: "您的密码已成功更改。现在可以使用新密码登录。",
  reset_password_desc: "请在下方输入您的新密码",
  password_required: "请输入您的密码",
  password_invalid: "密码必须至少8个字符，包含字母、数字和特殊字符",
  password_placeholder: "输入您的密码",
  confirm_password_required: "请确认您的密码",
  passwords_do_not_match: "您输入的两次密码不一致",
  confirm_password_placeholder: "确认密码",
  reset_password: "设置新密码",
  password_same_as_old: "新密码不能与旧密码相同",
  password_reset_failed: "密码重置失败",
};
